export enum NlpType {
  DIAGNOSIS = "diagnosis",
  MEMBER = "member",
  NEGATIVE_EXCLUSION = "negative_exclusion",
  OCR_MAPPING = "ocr_mapping",
}
